import { WebPlugin } from '@capacitor/core';
export class HttpLocalServerSwifterWeb extends WebPlugin {
    constructor() {
        super(...arguments);
        this.isRunning = false;
    }
    async connect() {
        this.isRunning = true;
        console.warn('[HttpLocalServerSwifter Web] Mock server started at 127.0.0.1:8080');
        return { ip: '127.0.0.1', port: 8080 };
    }
    async disconnect() {
        this.isRunning = false;
        console.log('[HttpLocalServerSwifter Web] Mock server stopped.');
    }
    async sendResponse(options) {
        if (!this.isRunning)
            throw new Error('Server not running');
        const { requestId, body, status, headers } = options;
        console.log(`[HttpLocalServerSwifter Web] Mock Response:`, { requestId, status: status !== null && status !== void 0 ? status : 200, headers: headers !== null && headers !== void 0 ? headers : {}, bodyLength: body.length });
    }
}
//# sourceMappingURL=web.js.map